




































































  declare let echarts: any;
  import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
  import { timeFormat } from "@/utils/index";
@Component({
  name: "PerformanceDashboardPerson"
})
export default class PerformanceDashboardPerson extends Vue {
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private isPets: any = true;
  @Provide() private chartRepay: any = [];
  @Provide() private chartDate: any = [];
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private chartLoadLeft: any = [];
  @Provide() private chartPerson: any = [];
  @Provide() private chartData: any = [];
  @Provide() private resultPersonalData: any = [];
  @Provide() private txt: any = this.$t;
  @Provide() private timeId: any = null; // 1 组  2 个人
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = this.getUid()?this.getUid():localStorage.getItem("userid"); // 如果在url上匹配到
  }
  private mounted() {
    this.forList(); // 获取列表数据
  }
  private destroyed() {
    let _id = this.timeId;
    clearTimeout(_id);
  }
  private forList() {
    this.getExtenList();
    this.timeId = setTimeout(() => {
      this.forList(); // 获取列表数据
    }, 300000);
  }
  private getUid() {
    if(this.$route.query&&this.$route.query.uid){
      return this.$route.query.uid;
    }
    return ""
  }
  private async getExtenList() {
    let _arg = {
      trackId: "",
      clientId: "",
      token: this.token,
      userid: Number(this.userid)
    }
    const { getUrgeDashboardApi }: any = await import("@/request/dashboard");
    let res = await getUrgeDashboardApi(_arg);
    if(res){
      this.personList(res);
    }
  }

  private personList(data: any){
    let _result_person: any = typeof data.staffstatsList == 'object'?data.staffstatsList:JSON.parse(data.staffstatsList);
    // let _person: any = _result_person.find((item: any) => {
    //   if(item.adminuid == this.userid){
    //     return item;
    //   }
    // });
    // if(_person){
      this.chartPerson = data.pies;
      this.updatedTime = timeFormat(this.chartPerson.updatetime);
    // }
    this.chartData = data.chartList;
    this.createCharts();
    if(_result_person) {
      this.resultPersonalData =_result_person;
    }
    // let _chart: any = typeof data.chartList == 'object'?data.chartList:JSON.parse(data.chartList);
  }
  private createCharts() {
    let _chart: any = this.chartData;
    if (_chart) {
      for (let i = 0; i < _chart.length; i++) {
        this.chartRepay.push(_chart[i].repaytotal);
        this.chartLoadLeft.push(_chart[i].loadleftunpaidprincipal);
        this.chartDate.push(_chart[i].date);
      }
      const ele = document.getElementById("my-table");
      let _chart_one = this.txt('performance.totalLeftUnpaidPrincipal');
      let _chart_two = this.txt('performance.repayPrincipal');
      const chart: any = echarts.init(ele);
      let options: any = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: [_chart_one, _chart_two]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {
              title: 'save as picture',
              type: 'png'
            },
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDate
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: _chart_one,
            type: "line",
            // stack: "总量",
            // data: [120, 132, 101, 134, 90, 230, 210]
            data: this.chartLoadLeft
          },
          {
            name: _chart_two,
            type: "line",
            // stack: "总量",
            data: this.chartRepay
          }
        ]
      };
      // this.options.series[0].data = this.chartLoadLeft;
      // options.series[0].data = [4000, 5000,5000,5000,5000,5000];
      // this.options.series[1].data = this.chartRapay;
      // options.series[1].data = [4000, 5000,5000,5000,5000,5000];
      chart.setOption(options);
      let myChart1 = echarts.init(document.getElementById('pets'));
      let myChart2 = echarts.init(document.getElementById('monthpets'));
      // let option1 = {
      //   title:{
      //     text:'按类型统计',
      //     top:'bottom',
      //     left:'center',
      //     textStyle:{
      //       fontSize: 14,
      //       fontWeight: '',
      //       color: '#333'
      //     },
      //   },//标题
      //   tooltip: {
      //     trigger: 'item',
      //     formatter: "{a} <br/>{b}: {c} ({d}%)",
      //     /*formatter:function(val){   //让series 中的文字进行换行
      //          var content = var['name'];
      //          return content;//返回可以含有html中标签
      //      },*/ //自定义鼠标悬浮交互信息提示,鼠标放在饼状图上时触发事件
      //   },//提示框,鼠标悬浮交互时的信息提示
      //   legend: {
      //     show: false,
      //             orient: 'vertical',
      //             x: 'left',
      //             data: ['50%-学生', '25%-老师', '25%-家长']
      //   },//图例属性,以饼状图为例,用来说明饼状图每个扇区,data与下边series中data相匹配
      //   graphic:{
      //     type:'text',
      //             left:'center',
      //             top:'center',
      //             style:{
      //       text:'用户统计\n'+'100', //使用“+”可以使每行文字居中
      //               textAlign:'center',
      //               font:'italic bolder 16px cursive',
      //               fill:'#000',
      //               width:30,
      //               height:30
      //     }
      //   },//此例饼状图为圆环中心文字显示属性,这是一个原生图形元素组件,功能很多
      //   series: [
      //     {
      //       name:'用户统计',//tooltip提示框中显示内容
      //       type: 'pie',//图形类型,如饼状图,柱状图等
      //       radius: ['35%', '65%'],//饼图的半径,数组的第一项是内半径,第二项是外半径。支持百分比,本例设置成环形图。具体可以看文档或改变其值试一试
      //       //roseType:'area',是否显示成南丁格尔图,默认false
      //       itemStyle: {
      //         normal:{
      //           label:{
      //             show:true,
      //             textStyle:{color:'#3c4858',fontSize:"18"},
      //             formatter:function(val){   //让series 中的文字进行换行
      //               return val.name.split("-").join("\n");}
      //           },//饼图图形上的文本标签,可用于说明图形的一些数据信息,比如值,名称等。可以与itemStyle属性同级,具体看文档
      //           labelLine:{
      //             show:true,
      //             lineStyle:{color:'#3c4858'}
      //           }//线条颜色
      //         },//基本样式
      //         emphasis: {
      //           shadowBlur: 10,
      //           shadowOffsetX: 0,
      //           shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
      //           textColor:'#000'
      //         }//鼠标放在各个区域的样式
      //       },
      //       data: [
      //         {value: 50, name: '50%-学生'},
      //         {value: 25, name: '25%-老师'},
      //         {value: 25, name: '25%-家长'},
      //       ],//数据,数据中其他属性,查阅文档
      //       color: ['#51CEC6','#FFB703','#5FA0FA'],//各个区域颜色
      //     },//数组中一个{}元素,一个图,以此可以做出环形图
      //   ]//系列列表
      // };
      let option1 = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: 10,
          data: [this.txt('performance.diffTargetRepayAmount'), this.txt('performance.totalRepayAmount')]
        },
        series: [
          {
            name: this.txt('performance.diffTargetRepayAmount'),
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '30',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {value: Number(this.chartPerson.todaydiff), name: this.txt('performance.diffTargetRepayAmount')},
              {value: this.chartPerson.repaytotal, name: this.txt('performance.totalRepayAmount'),
              }
            ],
            color: ['#f56c6c','#7f7c7c']
          }
        ]
      };
      myChart1.setOption(option1);
      let option2 = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: 10,
          data: [this.txt('performance.diffTargetRepayAmount'), this.txt('performance.totalRepayAmount')]
        },
        series: [
          {
            name: this.txt('performance.diffTargetRepayAmount'),
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '30',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {value: Number(this.chartPerson.halfmonthdiff), name: this.txt('performance.diffTargetRepayAmount')},
              {value: this.chartPerson.halfmonthrepaytotal, name: this.txt('performance.totalRepayAmount'),
              }
            ],
            color: ['#f56c6c','#7f7c7c']
          }
        ]
      };
      myChart2.setOption(option2);
    }
  }

  private createCircle() {
    let myChart1 = echarts.init(document.getElementById('pets'));
    // let option1 = {
    //   title:{
    //     text:'按类型统计',
    //     top:'bottom',
    //     left:'center',
    //     textStyle:{
    //       fontSize: 14,
    //       fontWeight: '',
    //       color: '#333'
    //     },
    //   },//标题
    //   tooltip: {
    //     trigger: 'item',
    //     formatter: "{a} <br/>{b}: {c} ({d}%)",
    //     /*formatter:function(val){   //让series 中的文字进行换行
    //          var content = var['name'];
    //          return content;//返回可以含有html中标签
    //      },*/ //自定义鼠标悬浮交互信息提示,鼠标放在饼状图上时触发事件
    //   },//提示框,鼠标悬浮交互时的信息提示
    //   legend: {
    //     show: false,
    //             orient: 'vertical',
    //             x: 'left',
    //             data: ['50%-学生', '25%-老师', '25%-家长']
    //   },//图例属性,以饼状图为例,用来说明饼状图每个扇区,data与下边series中data相匹配
    //   graphic:{
    //     type:'text',
    //             left:'center',
    //             top:'center',
    //             style:{
    //       text:'用户统计\n'+'100', //使用“+”可以使每行文字居中
    //               textAlign:'center',
    //               font:'italic bolder 16px cursive',
    //               fill:'#000',
    //               width:30,
    //               height:30
    //     }
    //   },//此例饼状图为圆环中心文字显示属性,这是一个原生图形元素组件,功能很多
    //   series: [
    //     {
    //       name:'用户统计',//tooltip提示框中显示内容
    //       type: 'pie',//图形类型,如饼状图,柱状图等
    //       radius: ['35%', '65%'],//饼图的半径,数组的第一项是内半径,第二项是外半径。支持百分比,本例设置成环形图。具体可以看文档或改变其值试一试
    //       //roseType:'area',是否显示成南丁格尔图,默认false
    //       itemStyle: {
    //         normal:{
    //           label:{
    //             show:true,
    //             textStyle:{color:'#3c4858',fontSize:"18"},
    //             formatter:function(val){   //让series 中的文字进行换行
    //               return val.name.split("-").join("\n");}
    //           },//饼图图形上的文本标签,可用于说明图形的一些数据信息,比如值,名称等。可以与itemStyle属性同级,具体看文档
    //           labelLine:{
    //             show:true,
    //             lineStyle:{color:'#3c4858'}
    //           }//线条颜色
    //         },//基本样式
    //         emphasis: {
    //           shadowBlur: 10,
    //           shadowOffsetX: 0,
    //           shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
    //           textColor:'#000'
    //         }//鼠标放在各个区域的样式
    //       },
    //       data: [
    //         {value: 50, name: '50%-学生'},
    //         {value: 25, name: '25%-老师'},
    //         {value: 25, name: '25%-家长'},
    //       ],//数据,数据中其他属性,查阅文档
    //       color: ['#51CEC6','#FFB703','#5FA0FA'],//各个区域颜色
    //     },//数组中一个{}元素,一个图,以此可以做出环形图
    //   ]//系列列表
    // };
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'horizontal',
        bottom: 10,
        data: ['差值金额', '回款总金额']
      },
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            {value: 335, name: '差值金额'},
            {value: 310, name: '回款总金额',
            }
          ],
          color: ['#f56c6c','#7f7c7c']
        }
      ]
    };
    myChart1.setOption(option);
  }
}
